import React, { useMemo } from 'react'
import { useRestaurant } from 'src/shared/components/common/restaurant_context/RestaurantContext'
import { useBrandedAppPromo } from '../../app_promo/useAppPromo'
import Image from 'shared/components/common/Image'
import Link from 'src/shared/components/common/link'
import { resources } from 'config'
import { t } from 'src/translations/src'
import { getMobileOS } from './getMobileOS'

export const CONSUMER_APP_LOGO_SRC = 'icons/toast/consumer-app-icon.svg'
const ANDROID_APP_LINK =
  'https://play.google.com/store/apps/details/Local_by_Toast?id=com.toasttab.consumer&hl=en_SG'
const IOS_APP_LINK =
  'https://apps.apple.com/us/app/toast-local-restaurants/id1362180579'

export const AppCTASection = () => {
  const { restaurant, ooRestaurant } = useRestaurant()

  const appPromoData = useBrandedAppPromo({
    skip: !!restaurant.content?.navConfig?.disableAppPromo
  })

  const shouldShowCTA = ooRestaurant?.consumerCTAEnabled

  const mobileOS = useMemo(getMobileOS, [])

  const [header, subtitle, logoSrc, cdnHost, linkHref] = useMemo(() => {
    if (appPromoData) {
      return [
        t('order-confirmation.app-cta.header-white-label', {
          appName: appPromoData.appName
        }),
        undefined,
        appPromoData.appLogo,
        resources.imagePrefix,
        appPromoData.link
      ]
    }
    return [
      t('order-confirmation.app-cta.header-consumer'),
      t('order-confirmation.app-cta.subtitle-consumer'),
      CONSUMER_APP_LOGO_SRC,
      undefined,
      mobileOS === 'android' ? ANDROID_APP_LINK : IOS_APP_LINK
    ]
  }, [appPromoData, mobileOS])

  if (!mobileOS) {
    return null
  }

  if (!appPromoData && !shouldShowCTA) {
    return null
  }

  return (
    <div
      className='orderConfirmationSection appCtaSection pdfHide'
      data-testid='app-cta-section'
      role='group'
      tabIndex={0}
    >
      <Image
        src={logoSrc}
        alt=''
        className='appLogo'
        cdnHost={cdnHost}
        data-testid='app-logo'
      />
      <div className='textContainer'>
        <h3>{header}</h3>
        {subtitle && <p>{subtitle}</p>}
      </div>
      <Link className='orderConfirmationButton appCta' href={linkHref || ''}>
        {t('order-confirmation.app-cta.get-the-app')}
      </Link>
    </div>
  )
}
